import { render, staticRenderFns } from "./Estadisticas2023.vue?vue&type=template&id=7a1a4edc"
import script from "./Estadisticas2023.vue?vue&type=script&lang=js"
export * from "./Estadisticas2023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports